import { render, staticRenderFns } from "./role-history-detail-modal.vue?vue&type=template&id=72e1a8d5&scoped=true&"
import script from "./role-history-detail-modal.vue?vue&type=script&lang=js&"
export * from "./role-history-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./role-history-detail-modal.vue?vue&type=style&index=0&id=72e1a8d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1a8d5",
  null
  
)

export default component.exports